import type { CSSProperties } from 'react';

/** Theme-aware primary actions for older controls that still use inline styles. */
export const primaryActionStyle: CSSProperties = {
  background: 'var(--primary-action-background, linear-gradient(135deg,var(--vo2-pink-400),var(--vo2-pink-600)))',
  color: 'var(--on-accent, #fff)',
  boxShadow: 'var(--nm-primary)',
};
